// 银行账户
export default {
  // 银行账户分页查询
  QUERY_BANKACCOUNT_PAGE: '/maindata/sysBankAccount/queryPage',
  // 银行账户新增/修改
  SAVE_BANKACCOUNT: '/maindata/sysBankAccount/saveBankAccount',
  // 银行账户详情
  QUERY_BANKACCOUNT_BY_ID: '/maindata/sysBankAccount/queryById',
  // 银行账户导出
  EXPORT_BANKACCOUNT: '/maindata/sysBankAccount/exportBankAccount',
  // 启用/禁用
  UPDATE_BANKACCOUNT: '/maindata/sysBankAccount/updateStatus',
  //银行账户批量导入
  IMPORT_BANKACCOUNT: '/maindata/sysBankAccount/importBankAccount',
};
